/* global VXBannerConfig */

import React                            from 'react';
import {render, unmountComponentAtNode} from 'react-dom';
import PjaxWrapper                      from '../utils/PjaxWrapper';
import {BannerSuite}                    from 'vxteaser';
import ActionProvider                   from '../components/VXTeaser/ActionProvider';
import TeaserHelper                     from '../utils/TeaserHelper';
import Flux                             from '../flux/Flux';
import Translations                     from '../utils/Translations';
import {isStartPage}                    from '../utils/CommonUtils';
import withSuspense                     from '../components/HigherOrderComponents/Utility/withSuspense';
import VXTeaserFeedbackPopup            from '../components/VXTeaser/VXTeaserFeedbackPopup.js';

const Halloween = React.lazy(() => import('../components/VXTeaser/components/Halloween'));

let containers;

const SPECIAL_BANNER = [
    Flux.Constants.SpecialEventsBanner.HALLOWEEN
];


function getBanner(bannerConfig, enableClose, containerSuffix, container) {
    const specialEventBanner = bannerConfig.filter(config => SPECIAL_BANNER.find(specialBanner => specialBanner === config.id)).shift(); // only the first element
    if (specialEventBanner) {
        switch (specialEventBanner.id) {
            case Flux.Constants.SpecialEventsBanner.HALLOWEEN:
                return <Halloween />;
            default:
                break;
        }
    }

    const onCloseFn = enableClose ? () => {
        container.className += " h-disp-none";
        TeaserHelper.hideTeaserContext(containerSuffix);
    } : null;

    bannerConfig = bannerConfig.filter(banner => !(banner.content === "" && banner.backgroundUrl1 === "" && banner.backgroundUrl2 === ""));

    if (bannerConfig.length === 0) {
        return;
    }

    let banner;
    const actionProvider = <ActionProvider>
              <BannerSuite configs={bannerConfig}
                           onCloseFn={onCloseFn}
                           autoplaySpeed={5000}
                           arrows={false}
                           dots={true}
                           onRenderNode={ActionProvider.renderCustomNode}
                           onHook={ActionProvider.renderHooks}
              />
              <VXTeaserFeedbackPopup />
          </ActionProvider>
    ;

    if (isStartPage) {
        banner = <div>
            <h1 className={"teaser-headline"}>{Flux.Browser.isSexole() ? Translations.get('seo_headlines.footer-h1_sexole') : Translations.get('seo_headlines.footer-h1')}</h1>
            {actionProvider}
        </div>;
    } else {
        banner = actionProvider;
    }

    return (banner);
}

/**
 * run function, adds listener
 */

function onReadyHandler(isCategoryVideoTeaser, containerSuffix, enableClose = true) {
    const bannerConfig = VXBannerConfig && VXBannerConfig[containerSuffix];

    if (!bannerConfig) {
        return null;
    }

    // render VX Teaser
    containers = document.getElementsByClassName('vxteaser-container-' + containerSuffix);
    for (const container of Array.from(containers)) {
        if (!TeaserHelper.isTeaserContextVisible(containerSuffix)) {
            container.className += " h-disp-none";
        }

        render(withSuspense(getBanner(bannerConfig, enableClose, containerSuffix, container)), container);

        PjaxWrapper.addUnloadFunc(() => {
            unmountComponentAtNode(container);
        });
    }
}

function run(...args) {
    const _onReady = onReadyHandler.bind(this, ...args);
    if (document.readyState !== 'loading') {
        _onReady();
    } else {
        window.addEventListener('DOMContentLoaded', _onReady);
    }
}


export {run};
